import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ api, onUploaded, label = "Upload image", testid = "image-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) { toast.error("Image is over 15MB."); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("alt", file.name.replace(/\.[^.]+$/, "").replace(/[-_]+/g, " "));
      const { data } = await api.post("/admin/media/upload", fd);
      onUploaded(data);
      toast.success("Image uploaded");
    } catch (err) { toast.error(err.response?.data?.detail || "Upload failed"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/heic,.heic" className="hidden" onChange={pick} data-testid={`${testid}-file`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testid}-btn`}
        className="inline-flex items-center gap-2 border-2 border-[#2D2D2D] px-3 py-2 text-xs font-head uppercase tracking-wide hover:bg-[#2D2D2D] hover:text-[#F3F1EC] transition-colors disabled:opacity-50">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {busy ? "Uploading…" : label}
      </button>
    </>
  );
}
